import React, { Component, Fragment } from 'react';
import { ProductCompliance } from '~/Api/CzSuklCompliance';
import { formatHumanDate } from '~/DateTime';
import Icon from '~/UI/Icon/Icon';

import styles from './styles.less';
import { TailwindTooltip } from '~/libs/ui/atoms/TailwindTooltip/TailwindTooltip';

interface Props {
	compliance: ProductCompliance;
}

export default class ComplianceIcon extends Component<Props> {
	// eslint-disable-next-line react/sort-comp
	render() {
		const { compliance } = this.props;
		const title = compliance.resolveRuleDescription();

		return title ? (
			<TailwindTooltip
				reference={
					<>
						<Icon name={this.resolveIconName()} />
						<span className='absolute right-full top-0 -mr-1 -mt-1 w-3 h-3 leading-3 rounded-full text-[11px] font-semibold bg-white text-center'>
							?
						</span>
					</>
				}
				displayClass='inline-block mr-1 h-4 align-middle'
				position='left'
			>
				{title}
				{compliance.decisionComment ? (
					<Fragment>
						<hr className={styles.line} />
						{compliance.decisionComment}
					</Fragment>
				) : null}
				<p className={styles.subPerex}>
					Poznámky ref. zdroje {compliance.czechReferenceDataSources.version} z&nbsp;
					{formatHumanDate(compliance.czechReferenceDataSources.effectiveSince, ['cs-CZ'])}
				</p>
			</TailwindTooltip>
		) : (
			<span className={styles.icon}>
				<Icon name={this.resolveIconName()} />
			</span>
		);
	}

	resolveIconName(): string {
		const { compliance } = this.props;

		if (compliance.isAccept) {
			return 'green-checkmark';
		}
		if (compliance.isAcceptNoRulesForDataSource) {
			return 'green-checkmark';
		}
		if (compliance.isAcceptWithWarning) {
			return 'yellow-question-mark';
		}
		if (compliance.isCannotInterpretRules) {
			return 'yellow-question-mark';
		}
		if (compliance.isReject) {
			return 'red-exclamation-mark';
		}
		if (compliance.isRejectNoPrices) {
			return 'red-exclamation-mark';
		}
		if (compliance.isRejectNotAReferenceDataSource) {
			return 'red-exclamation-mark';
		}
		if (compliance.isRejectRemoved) {
			return 'red-exclamation-mark';
		}
		return 'yellow-question-mark';
	}
}
